import { API } from "@/main.js";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  fetchTickets() {
    return new Promise((resolve, reject) => {
      API.tickets.getTickets(
        resp => {
          let tickets = resp.data;
          for (let i = 0; i < tickets.length; i++) {
            if (
              tickets[i].deleted === 1 ||
              tickets[i].visibility === "private"
            ) {
              tickets.splice(i, 1);
              i--;
            }
          }
          resolve(tickets);
        },
        error => {
          reject(error.response);
        }
      );
    });
  },

  fetchTicketByID({ commit }, ticketID) {
    return new Promise((resolve, reject) => {
      API.tickets.getTicketByID(
        ticketID,
        resp => {
          let ticket = resp.data;
          resolve(ticket);
        },
        error => {
          reject(error.response);
        }
      );
    });
  },

  createTicket({ commit }, newData) {
    return new Promise((resolve, reject) => {
      API.tickets.createTicket(
        newData,
        resp => {
          let ticket = resp.data.data;
          resolve(ticket);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchTicketComments({ commit }, ticketID) {
    return new Promise((resolve, reject) => {
      API.tickets.getTicketComments(
        ticketID,
        resp => {
          let comments = resp.data;
          resolve(comments);
        },
        error => {
          reject(error.response);
        }
      );
    });
  },

  createComment({ commit }, { formData, ticketID }) {
    return new Promise((resolve, reject) => {
      API.tickets.createComment(
        formData,
        ticketID,
        resp => {
          let comment = resp.data.data;
          resolve(comment);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchCommentByID({ commit }, { commentID, ticketID }) {
    return new Promise((resolve, reject) => {
      API.tickets.getCommentByID(
        commentID,
        ticketID,
        resp => {
          let comment = resp.data;
          resolve(comment);
        },
        error => {
          reject(error.response);
        }
      );
    });
  },

  deleteTicketByID({ commit }, id) {
    return new Promise((resolve, reject) => {
      API.tickets.deleteTicket(
        id,
        resp => {
          resolve(resp);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  editTicket({ commit }, { newData, ticketID }) {
    return new Promise((resolve, reject) => {
      API.tickets.editTicket(
        newData,
        ticketID,
        resp => {
          let ticket = resp.data.data;
          resolve(ticket);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  deleteCommentByID({ commit }, { commentID, ticketID }) {
    return new Promise((resolve, reject) => {
      API.tickets.deleteComment(
        commentID,
        ticketID,
        resp => {
          resolve(resp);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  editComment({ commit }, { newData, ticketID, commentID }) {
    return new Promise((resolve, reject) => {
      API.tickets.editComment(
        newData,
        ticketID,
        commentID,
        resp => {
          let comment = resp.data.data;
          resolve(comment);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  createTicketAttachment({ commit }, { formData, ticketID }) {
    return new Promise((resolve, reject) => {
      API.tickets.createTicketAttachment(
        formData,
        ticketID,
        resp => {
          let comment = resp.data.data;
          resolve(comment);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  createCommentAttachment({ commit }, { formData, ticketID, commentID }) {
    return new Promise((resolve, reject) => {
      API.tickets.createCommentAttachment(
        formData,
        ticketID,
        commentID,
        resp => {
          let comment = resp.data.data;
          resolve(comment);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  deleteTicketAttachmentByID({ commit }, { ticketID, attachmentID }) {
    return new Promise((resolve, reject) => {
      API.tickets.deleteTicketAttachment(
        ticketID,
        attachmentID,
        resp => {
          resolve(resp);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  deleteCommentAttachmentByID(
    { commit },
    { ticketID, commentID, attachmentID }
  ) {
    return new Promise((resolve, reject) => {
      API.tickets.deleteCommentAttachment(
        ticketID,
        commentID,
        attachmentID,
        resp => {
          resolve(resp);
        },
        error => {
          reject(error);
        }
      );
    });
  }
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/tickets.js